class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }
  
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    //waits until cart has finished loading, then checks total and adds/removes appropriate gift wrapping - also done during cart updates in cart.js
    var cartTotal = document.getElementById('giftwrap-total').innerHTML;//gets cart total
    var wrapPrice = document.getElementById('giftwrap-price').innerHTML;//gets the price of paid wrapping in customer's currency
    //checks session storage values set by gift-wrapping.js
    var wrapAdded = sessionStorage.getItem('giftwrapAdded');
    var wrapPaid = sessionStorage.getItem('giftwrapPaid');
    var wrapFree = sessionStorage.getItem('giftwrapFree');
    if (wrapAdded == 'true') {
      //if paid wrapping is in cart and price is US, replaces paid wrapping with free wrapping when cart total without the wrapping price becomes more than 350
      if (wrapPaid == 'true' && document.getElementById('localisation_US') && (Number(cartTotal) - Number(wrapPrice)) >= Number(350)){
        sessionStorage.setItem('giftwrapPaid', 'false');
        sessionStorage.setItem('giftwrapFree', 'true');
        document.getElementById('giftwrap-remove').click();
        setTimeout(function(){
          document.getElementById('giftwrap-submit').click();
        }, 500);
      //if free wrapping is in cart and price is US, replaces free wrapping with paid wrapping when cart total becomes less than 350
      } else if (wrapFree == 'true' && document.getElementById('localisation_US') && Number(cartTotal) < Number(350)) {
        sessionStorage.setItem('giftwrapFree', 'false');
        sessionStorage.setItem('giftwrapPaid', 'true');
        document.getElementById('giftwrap-remove').click();
        setTimeout(function(){
          document.getElementById('giftwrap-submit').click();
        }, 500);
      //if paid wrapping is in cart and price is AU, replaces paid wrapping with free wrapping when cart total without the wrapping price is more than 500
      } else if (wrapPaid == 'true' && document.getElementById('localisation_AU') && (Number(cartTotal) - Number(wrapPrice)) >= Number(500)){
        sessionStorage.setItem('giftwrapPaid', 'false');
        sessionStorage.setItem('giftwrapFree', 'true');
        document.getElementById('giftwrap-remove').click();
        setTimeout(function(){
          document.getElementById('giftwrap-submit').click();
        }, 500);
      //if free wrapping is in cart and price is AU, replaces free wrapping with paid wrapping when cart total becomes less than 500
      } else if (wrapFree == 'true' && document.getElementById('localisation_AU') && Number(cartTotal) < Number(500)) {
        sessionStorage.setItem('giftwrapFree', 'false');
        sessionStorage.setItem('giftwrapPaid', 'true');
        document.getElementById('giftwrap-remove').click();
        setTimeout(function(){
          document.getElementById('giftwrap-submit').click();
        }, 500);
      }
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);